<template>
<div id="globalAlert">
  <v-alert
    :value="message != null"
    :color="message && 'color' in message ? message.color : 'error'"
    dark
    border="top"
    icon="notifications_active"
    transition="slide-x-reverse-transition"
  >
    <span v-if="message != null" v-html="message.message">

    </span>
  </v-alert>
</div>
</template>

<script>
export default {
  data() {
      return {
          message: null,
          alertLife: 0
      }
  },

  mounted() {
    this.$bus.$on('showAlert', async (message, color='error', aliveTime='4500') => {
      // Keep a permanent log of errors since alerts have a timeout
      if (color == 'error') {
        console.warn('Error Log: ');
        console.warn(message);
      }

      // no action if message is already being shown
      if (this.message && message == this.message.message)
        return

      // Clear an existing notification if it exists
      if (this.message != null) {
        const causeDelay = (delayInms) => {
          return new Promise(resolve  => {
            setTimeout(() => {
              resolve(2);
            }, delayInms);
          });
        }

        // Destroy existing notification
        this.message = null
        clearTimeout(this.alertLife)

        // Cause a delay before opening next notification to make if obvious it's new
        await causeDelay(200)
      }

      this.message = {
        message: message,
        color: color
      }

      this.alertLife = setTimeout(() => {
        this.message = null
      }, aliveTime)
    })
  },
}
</script>

<style>
  #globalAlert .v-alert {
    position: fixed !important;
    top: 10px !important;
    right: 10px;

    z-index: 999;
  }
  #globalAlert .v-icon.v-icon {
    margin-right: 10px !important;
  }
  #globalAlert .v-alert__content span {
    color: white !important;
  }
</style>
